export const parseSubscriptionDate = (value) => {
  if (!value) return null;

  const stringValue = String(value);

  /*
   * Évite le décalage de date provoqué par UTC avec les DATEONLY.
   */
  const dateOnlyMatch = stringValue.match(
    /^(\d{4})-(\d{2})-(\d{2})$/,
  );

  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch;

    const date = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
    );

    return Number.isNaN(date.getTime()) ? null : date;
  }

  const date = new Date(value);

  return Number.isNaN(date.getTime()) ? null : date;
};

export const startOfLocalDay = (value = new Date()) => {
  const date =
    value instanceof Date
      ? new Date(value)
      : parseSubscriptionDate(value);

  if (!date) return null;

  date.setHours(0, 0, 0, 0);

  return date;
};

export const getDaysBetween = (startValue, endValue) => {
  const start = startOfLocalDay(startValue);
  const end = startOfLocalDay(endValue);

  if (!start || !end) return null;

  return Math.ceil(
    (end.getTime() - start.getTime()) /
      (1000 * 60 * 60 * 24),
  );
};

export const getDaysUntil = (
  targetValue,
  referenceValue = new Date(),
) => getDaysBetween(referenceValue, targetValue);

export const isDatePast = (
  targetValue,
  referenceValue = new Date(),
) => {
  const target = startOfLocalDay(targetValue);
  const reference = startOfLocalDay(referenceValue);

  if (!target || !reference) return false;

  return target < reference;
};

export const calculateSubscriptionProgress = ({
  itemType,
  startDate,
  endDate,
  referenceDate = new Date(),
}) => {
  if (itemType === "one_time") {
    return null;
  }

  const start = startOfLocalDay(startDate);
  const end = startOfLocalDay(endDate);
  const reference = startOfLocalDay(referenceDate);

  if (!start || !end || !reference) {
    return null;
  }

  const totalDuration = end.getTime() - start.getTime();

  if (totalDuration <= 0) {
    return null;
  }

  const elapsedDuration =
    reference.getTime() - start.getTime();

  const percentage = Math.min(
    Math.max((elapsedDuration / totalDuration) * 100, 0),
    100,
  );

  return {
    percentage,
    daysRemaining: Math.max(
      getDaysBetween(reference, end) || 0,
      0,
    ),
    isExpired: reference > end,
    hasStarted: reference >= start,
  };
};